<div class="page-inner main">
    <h1>{{'PRIVACY.HEADER' | translate}}</h1>
    <p *ngFor="let par of paragraphs$ | async">{{par}}</p>
</div>